module.exports = __webpack_public_path__ + "img/soccerboard01.3cb37881.jpg";